/**
 * Scene 7 Player Integration for ecommerce product detail pages.
 *
 * @author Marc Althoff, Yves DeBrune
 * @namespace SCS.scene7
 */
(function ($, SCS) {
	'use strict';
	// read only:
	/* globals container, Set1, Set2, s7width, s7height, s7params, s7sdk, s7flyoutzoomview, s7zoomview, s7spinview */
	// read-write:
	/* globals s7swatches:true, s7ZoomMode:true */
	/* jshint camelcase: false */

	SCS.scene7 = SCS.scene7 || {};
	$(function () {

		/**
		 * Get a spinset from the server, calls getMediaSets_spinset
		 *
		 * @method SCS.scene7.getMediaSet_1
		 */
		SCS.scene7.getMediaSet_1 = function () {
			if (Set1.length) {
				s7params.params.asset = Set1;
				SCS.scene7.Set1 = new s7sdk.MediaSet(null, s7params, null);
				SCS.scene7.Set1.addEventListener(s7sdk.AssetEvent.NOTF_SET_PARSED, SCS.scene7.getMediaSet_2, false);
			} else {
				SCS.scene7.getMediaSet_2();
			}
		};

		/**
		 * Get a spinset from the server, calls onSetsParsed
		 *
		 * @method SCS.scene7.getMediaSet_2
		 */
		SCS.scene7.getMediaSet_2 = function () {
			if (Set2.length) {
				s7params.params.asset = Set2;
				SCS.scene7.Set2 = new s7sdk.MediaSet(null, s7params, null);
				SCS.scene7.Set2.addEventListener(s7sdk.AssetEvent.NOTF_SET_PARSED, SCS.scene7.onSetsParsed, false);
			} else {
				SCS.scene7.onSetsParsed();
			}
		};

		/**
		 * Event Handler called after the Scene 7 Sets are parsed
		 *
		 * @method SCS.scene7.onSetsParsed
		 * @param {Object} e event
		 */
		SCS.scene7.onSetsParsed = function () {
			var	compAsset = new s7sdk.MediaSetDesc(0, 0, s7sdk.ItemDescType.MEDIA_SET, '', '');

			SCS.scene7.addSetToComposite(compAsset, SCS.scene7.Set1);
			SCS.scene7.addSetToComposite(compAsset, SCS.scene7.Set2);

			// set media set for Swatches to display
			s7swatches = new s7sdk.Swatches('s7container', s7params, 'swatches');
			s7swatches.addEventListener(s7sdk.AssetEvent.SWATCH_SELECTED_EVENT, SCS.scene7.swatchSelected, false);
			s7swatches.setMediaSet(compAsset);
			SCS.scene7.alignSwatches(s7swatches, compAsset, s7params);

			// select the first swatch
			s7swatches.selectSwatch(0, true);

			container.addEventListener(s7sdk.ResizeEvent.COMPONENT_RESIZE, SCS.scene7.onResize, false);
			container.addEventListener(s7sdk.ResizeEvent.WINDOW_RESIZE, SCS.scene7.onResize, false);

			SCS.scene7.styleSwatches();
		};

		/**
		 * Adds styling (indicators for spinview and – later – video) to the swatches
		 *
		 * @method SCS.scene7.styleSwatches
		 */
		SCS.scene7.styleSwatches = function () {
			// Parse the swatches element and check for videos / 360 spinsets
			var spinSnippet = '<div class="spinner"></div>',
				mySwatches = s7swatches.filteredSet_;

			for (var key in mySwatches) {
				if (mySwatches.hasOwnProperty(key)) {
					if (+mySwatches[key].type === 8) {
						$('#s7container #swatches div div').eq(0).addClass('container');
						$('#s7container #swatches .container > div').eq(key).css({
							'position': 'absolute'
						}).append(spinSnippet);
					}
				}
			}
		};

		/**
		 * Adds a mediaset (e.g. an imageset and a spinset) to a Scene7 "Composite"
		 *
		 * @method SCS.scene7.addSetToComposite
		 * @param {Object} composite
		 * @param {Object} set
		 */
		SCS.scene7.addSetToComposite = function (composite, set) {
			if (set) {
				var	mset = set.mediaSetDesc_;

				if (mset.type === s7sdk.ItemDescType.IMAGE_SET) {
					for (var i = 0; i < mset.items.length; i+=1) {
						composite.items.push(mset.items[i]);
					}
				} else {
					composite.items.push(mset);
				}
			}
		};

		/**
		 * change the image displayed in the main view every time the swatch selection changes
		 *
		 * @method SCS.scene7.swatchSelected
		 * @param {Object} e event
		 */
		SCS.scene7.swatchSelected = function (e) {
			var asset = e.s7event.asset,
				type = asset.type;

			// Hide all
			$('#flyoutzoomview').hide();
			$('#zoomview').hide();
			$('#spinview').hide();
			$('.spinsetSpinner').hide();

			if (+type === 1) { // ImageSet

				// always set asset in both viewers
				s7flyoutzoomview.setItem(asset);
				s7zoomview.setItem(asset);

				if (s7ZoomMode === 'ZoomView') {
					$('#zoomview').show();
				}

				if (s7ZoomMode === 'FlyoutZoomView') {
					$('#flyoutzoomview').show();
				}

				return;
			}

			if (+type === 8) { // SpinView
				s7params.params.asset = asset.name;
				s7spinview.setMediaSet(asset);


				$('.spinsetSpinner').show();
				$('.spinsetSpinner').slider('destroy').slider({
					animate: 'fast',
					max: s7spinview.getFramesLength() - 1,
					slide: SCS.scene7.sliderToSpinnerSync,
					start: SCS.scene7.sliderStartDrag,
					stop: SCS.scene7.sliderStopDrag
				}).data('s7spinview', s7spinview);

				$('#spinview').show();

				setTimeout(
					function () {
						// jump to "first" (technically last) frame
						$('.spinsetSpinner').data('s7spinview').setCurrentFrameIndex(s7spinview.getFramesLength() - 1);
					}, 100
				);

				return;
			}
		};

		/**
		 * Slider helper function on drag
		 *
		 * @method SCS.scene7.sliderStartDrag
		 * @param {Object} event
		 */
		SCS.scene7.sliderStartDrag = function () {
			$(this).data('isDragging', true);
		};

		/**
		 * Slider helper function on drag
		 *
		 * @method SCS.scene7.sliderStopDrag
		 * @param {Object} event
		 * @param {Object} ui
		 */
		SCS.scene7.sliderStopDrag = function () {
			$(this).data('isDragging', false);
		};

		/**
		 * syncs slider movement to the spinner
		 *
		 * Spinsets should adhere to the following logic:
		 * - 36 frames
		 * - start with frame 0 = Front
		 * - end with frame 35 (10° left to front)
		 * - rotation is counterclockwise around the z axis (you "push" on the right side of the device to get to frame n + 1)
		 *
		 * @method SCS.scene7.sliderToSpinnerSync
		 * @param {Object} event
		 */
		SCS.scene7.sliderToSpinnerSync = function (event, ui) {
			var $ctx = $(this),
				gotoFrame = (s7spinview.getFramesLength() - 1) - ui.value;

			if (gotoFrame >= 0) {
				$ctx.data('s7spinview').setCurrentFrameIndex(gotoFrame);
			}
		};

		/**
		 * syncs spinner movement to the slider
		 *
		 * @method SCS.scene7.spinnerToSliderSync
		 * @param {Object} e event
		 */
		SCS.scene7.spinnerToSliderSync = function (e) {
			var frame = e.s7event.frame,
				gotoFrame = (s7spinview.getFramesLength() - 1) - frame,
				slider = $('.spinsetSpinner');

			if (gotoFrame >= 0) {
				if (!slider.data('isDragging')) {
					slider.slider('option', 'value', gotoFrame);
				}
			}
		};

		/**
		 * Aligns the swatches after the set is parsed
		 *
		 * @method SCS.scene7.alignSwatches
		 * @param {Object} inSwatches
		 * @param {Object} inMediaSetDesc
		 * @param {Object} inParams
		 */
		SCS.scene7.alignSwatches = function (inSwatches, inMediaSetDesc) {
			var tw = parseInt(s7sdk.Util.css.getCss('s7thumb', 'width', inSwatches.id, 's7swatches'), 10),
				dw = Number(inSwatches.cellSpacing.horizontalSpacing),
				width = inMediaSetDesc.items.length * (tw + dw) + dw,
				swWidth = width,
				swHeight = inSwatches.obj.getHeight(),
				contr = document.getElementById('s7container');
			if ((width > contr.offsetWidth)) {
				swWidth = contr.offsetWidth;
			} else if ((width <= contr.offsetWidth)) {
				swWidth = width;
			}

			if (contr.offsetHeight < inSwatches.obj.getHeight()) {
				swHeight = contr.offsetHeight;
			}
			inSwatches.resize(swWidth, swHeight);
			inSwatches.obj.style.left = (contr.offsetWidth - inSwatches.obj.getWidth()) / 2 + 'px';
		};

		/**
		 * Toggles between the fullscreen ZoomView and the standard view
		 * by enabling various DOM elements
		 *
		 * @method SCS.scene7.toggleZoomView
		 */
		SCS.scene7.toggleZoomView = function () {
			$('#s7containerContainer').toggleClass('zoomView');

			if (s7ZoomMode === 'FlyoutZoomView') {
				// default -> wechsel in ZoomView
				$('#scs-pageheader-logo a').css({
					'zIndex': 9999,
					'position': 'absolute',
					'left': '50px'
				});
				$('body').css({
					'overflow': 'hidden'
				});
				$('#flyoutzoomview').hide();

				// ... and enter 'full window' overlay mode
				var size = SCS.scene7.getWindowSize();
				container.resize(size.w, size.h);
				s7swatches.resize(size.w - 2, 90); // s7swatches.size.height

				s7zoomview.resize(size.w, size.h);
				s7spinview.resize(size.w, size.h);

				if ($('#spinview').css('display') === 'block') {
					$('#zoomview').hide();
				} else {
					$('#spinview').hide();
					$('#zoomview').show();
				}

				// switch zo Zoomview ...
				s7ZoomMode = 'ZoomView';

			} else {
				$('#scs-pageheader-logo a').css({
					'zIndex': 9999,
					'position': 'relative',
					'left': 'auto'
				});
				$('body').css({
					'overflow': 'visible'
				});

				// switch zo FlyoutZoomView ...
				s7ZoomMode = 'FlyoutZoomView';
				container.resize(s7width, s7height);
				s7flyoutzoomview.resize(s7width, s7height); // ?
				s7swatches.resize(s7width - 2, 360);
				s7spinview.resize(s7width, s7height);

				$('#zoomview').hide();

				if ($('#spinview').css('display') !== 'block') {
					$('#spinview').hide();
					$('#flyoutzoomview').show();
				}
			}

			SCS.scene7.styleSwatches();
		};

		/**
		 * Event Handler function for toggleZoomView
		 *
		 * @method SCS.scene7.onResize
		 * @param {Object} event
		 */
		SCS.scene7.onResize = function (event) {
			if ((s7ZoomMode === 'ZoomView' && event.type === 'windowResize') || (event.type === 'componentResize')) {
				// only when changing viewmodes
				if (s7ZoomMode === 'ZoomView') {
					if (container) {
						container.resize(event.s7event.w, event.s7event.h);
					}
				}
				if (s7swatches) {
					s7swatches.resize(event.s7event.w - 2, s7swatches.size.height); // Exclude the border width (2px)
				}
				if (s7spinview) {
					s7spinview.resize(event.s7event.w, event.s7event.h);
				}
				if (s7zoomview) {
					s7zoomview.resize(event.s7event.w, event.s7event.h);
				}
			}
		};

		/**
		 * Helper function for toggleZoomView - getWindowSize
		 *
		 * @method SCS.scene7.getWindowSize
		 * @param {Object} event
		 */
		SCS.scene7.getWindowSize = function () {
			var	size = new s7sdk.Point2D(),
				winW = 630,
				winH = 460;

			if (document.body && document.body.offsetWidth) {
				winW = document.body.offsetWidth;
				winH = document.body.offsetHeight;
			}
			if (document.compatMode === 'CSS1Compat' &&
				document.documentElement &&
				document.documentElement.offsetWidth) {
				winW = document.documentElement.offsetWidth;
				winH = document.documentElement.offsetHeight;
			}
			if (window.innerWidth && window.innerHeight) {
				winW = window.innerWidth;
				winH = window.innerHeight;
			}

			size.w = winW;
			size.h = winH;
			return size;
		};

	});

})(window.$, window.SCS = window.SCS || {});



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/components/scene7player.js
// module id = 78
// module chunks = 0